import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import QuesPane from "./QuesPane"
import { BackTop } from "antd"
export class ExamPane extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  scrollToAnchor = (anchorName) => {
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    }
  }
  componentWillReceiveProps(nextProps) {

    if (nextProps.quesStore.curQuesIndex !== this.props.quesStore.curQuesIndex) {
      this.scrollToAnchor(`queStoreQuesPane${nextProps.quesStore.curQuesIndex}`);
    }
  }
  render() {
    let { fetchQuesCreateChapterSuccess, fontSize, } = this.props.quesStore;
    let Data = fetchQuesCreateChapterSuccess;
    if (!Data) return null;
    const { list, practiceId, resultId, } = Data;
    return (
      <div className="ques-store-exam-pane">
        {
          list.map((item, index) => (
            <QuesPane
              key={item.ID}
              data={item}
              index={index}
              fontSize={fontSize}
              practiceId={practiceId}
              resultId={resultId}
              busType={1}
              ExamModel={1}
            />
          ))
        }
        <BackTop />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExamPane);



// WEBPACK FOOTER //
// ./src/features/ques-store/ExamPane.js